const question = {
    waitForRaising: { point: [3] },
    agreeForLittleLoss: { point: [1] },
    worryOnBiggestLoss: { point: [2] },
};
export default question;
